export default {
  namespaced: true,
  state: {
    isUpdateApplyList: false, // 是否更新申请列表
    isUpdateApproveList: false, // 是否更新审核列表
  },
  getters: {
    isUpdateApplyList: state => state.isUpdateApplyList,
    isUpdateApproveList: state => state.isUpdateApproveList,
  },
  mutations: {
    // 更新申请列表
    updateApplyList(state, data) {
      state.isUpdateApplyList = data;
    },
    // 更新审核列表
    updateApproveList(state, data) {
      state.isUpdateApproveList = data;
    },
  },
  actions: {},
};
